<section>
  <molec-profile-edit-form [requireForm]="ui.requireForm" (submitEvent)="action.emit($event)"></molec-profile-edit-form>

  <molec-profile-info-form (submitEvent)="action.emit($event)" [currentGenres]="ui.currentGenres" [genres]="data.genres" [optionalForm]="ui.optionalForm"
    [experienceForm]="ui.experienceForm" class="mb-4"></molec-profile-info-form>
</section>